<template>
   <g>
      <path
         d="M7.50039 8.7249C8.17694 8.7249 8.72539 8.17645 8.72539 7.4999C8.72539 6.82335 8.17694 6.2749 7.50039 6.2749C6.82384 6.2749 6.27539 6.82335 6.27539 7.4999C6.27539 8.17645 6.82384 8.7249 7.50039 8.7249Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M11.0208 8.44367C11.3995 8.26937 11.5892 8.18257 11.6445 8.09577C11.6998 8.00967 11.6998 7.87177 11.6998 7.59737V7.40277C11.6998 7.12767 11.6998 6.99047 11.6445 6.90437C11.5892 6.81757 11.3995 6.73077 11.0208 6.55647C10.4587 6.29747 10.0975 5.73257 10.1171 5.14037C10.1318 4.68817 10.1395 4.46207 10.0898 4.37667C10.0408 4.29057 9.9218 4.22547 9.6852 4.09527L9.4591 3.97137C9.2281 3.84537 9.1133 3.78237 9.0153 3.78727C8.9173 3.79147 8.7493 3.90487 8.4154 4.13167C8.14427 4.31211 7.82584 4.40838 7.50015 4.40838C7.17446 4.40838 6.85604 4.31211 6.5849 4.13167C6.2503 3.90487 6.0837 3.79147 5.985 3.78657C5.887 3.78237 5.7715 3.84537 5.5412 3.97137L5.3151 4.09527C5.0778 4.22547 4.9595 4.29057 4.9105 4.37597C4.8615 4.46207 4.8685 4.68817 4.8825 5.14037C4.9021 5.73257 4.5409 6.29817 3.9795 6.55647C3.6001 6.73077 3.4104 6.81757 3.3551 6.90437C3.2998 6.99047 3.2998 7.12837 3.2998 7.40277V7.59737C3.2998 7.87247 3.2998 8.01037 3.3551 8.09577C3.4104 8.18257 3.6001 8.26937 3.9788 8.44367C4.5409 8.70267 4.9021 9.26757 4.8825 9.85977C4.8678 10.312 4.8601 10.5381 4.9098 10.6235C4.9588 10.7096 5.0778 10.7747 5.3151 10.9049L5.5405 11.0288C5.7715 11.1548 5.8863 11.2178 5.9843 11.2136C6.0823 11.2094 6.2503 11.0953 6.5842 10.8685C6.85549 10.6877 7.17418 10.5913 7.50015 10.5913C7.82613 10.5913 8.14482 10.6877 8.4161 10.8685C8.75 11.0953 8.9173 11.2087 9.016 11.2129C9.114 11.2178 9.2295 11.1548 9.4598 11.0288L9.6852 10.9049C9.9232 10.7747 10.0422 10.7096 10.0912 10.6235C10.1402 10.5381 10.1325 10.312 10.1178 9.85977C10.0982 9.26757 10.4587 8.70197 11.0208 8.44367Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
      <path
         d="M12.4 0.500005V2.5013C11.0928 1.21669 9.33275 0.497832 7.5 0.500005C3.6339 0.500005 0.500001 3.6339 0.500001 7.5C0.499372 8.46347 0.697643 9.4167 1.0824 10.3M2.6 14.5V12.4987C3.90719 13.7833 5.66725 14.5022 7.5 14.5C11.3661 14.5 14.5 11.3661 14.5 7.5C14.5006 6.53654 14.3024 5.58331 13.9176 4.7"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-study-setup',
         viewBox: '0 0 15 15',
         width: 15,
         height: 15,
         fill: 'none',
      };
   },
};
</script>
